import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import NotFound from "../pages/NotFound";
import { StudentApplications } from "./components/StudentApplications";

export default function ApplicationRoutes({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          roles={[0, 1, 4]}
          component={StudentApplications}
          path={`${path}/`}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
